import { writable } from "svelte/store";

export interface RecentlyRemovedProduct {
  id: number;
  index: number;
  orderId: number;
  warehouseId: number | null;
  distributorId: number;
  productLineId: number;
  productLineName: string;
}

const defaultState = null;

export default writable<RecentlyRemovedProduct>(defaultState);
